<template>
    <div class="material-library-page">
      <div class="material-library-container">
        <div class="title-bg">供应商库</div>
        <!-- 搜索区域 -->
        <v-card class="search-card">
          <v-card-text>
            <v-row class="align-center">
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="searchForm.keyword"
                  label="关键字搜索"
                  persistent-placeholder
                  prepend-inner-icon="mdi-magnify"
                  variant="outlined"
                  hide-details
                  density="compact"
                  clearable
                  class="search-input"
                  placeholder="供应商唯一码/公司全称/联系人"
                  @keyup.enter="handleSearch"
                  @click:clear="handleSearch"
                />
              </v-col>
              <v-col cols="12" sm="5">
                <div class="d-flex gap-2">
                  <v-btn
                    color="primary"
                    variant="flat"
                    @click="handleSearch"
                    class="search-btn"
                    density="comfortable"
                  >
                    查询
                  </v-btn>
                  <v-btn
                    color="primary"
                    variant="flat"
                    @click="handleReset"
                    class="search-btn"
                    density="comfortable"
                  >
                    重置
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" sm="3">
                <div class="d-flex justify-end">
                  <v-btn
                    color="primary"
                    variant="flat"
                    @click="handleAdd"
                    class="search-btn"
                    density="comfortable"
                  >
                    新增供应商
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
  
        <!-- 表格区域 -->
        <v-card class="table-card">
          <v-card-text class="pa-0">
            <v-table class="material-table" hover>
              <thead>
                <tr>
                  <th v-for="header in headers" :key="header.key" :class="['text-' + header.align]" :style="{ width: header.width }">
                    {{ header.title }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="loading" class="text-center">
                  <td :colspan="headers.length" class="py-8">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    <div class="mt-2">加载中...</div>
                  </td>
                </tr>
                <tr v-else-if="supplierList.length === 0" class="text-center">
                  <td :colspan="headers.length" class="py-8">暂无数据</td>
                </tr>
                <template v-else>
                  <tr v-for="(item, index) in supplierList" :key="item.id || index">
                    <td class="text-center">
                      {{ item.code }}
                    </td>
                    <td class="text-center">
                      {{ item.companyName }}
                    </td>
                    <td class="text-center">
                      {{ item.type || '/' }}
                    </td>
                    <td class="text-center">
                      {{ item.openingBank || '/' }}
                    </td>
                    <td class="text-center">
                      {{ item.bankAccount || '/' }}
                    </td>
                    <td class="text-center">
                      {{ item.contactPerson || '/' }}
                    </td>
                    <td class="text-center" style="word-break: break-all;">
                      {{ item.phone || '/' }}
                    </td>
                    <td class="text-center">
                      {{ item.supplierAddress || '/' }}
                    </td>
                    <td class="text-center">
                      {{ item.taxType || '/' }}
                    </td>
                    <!-- <td class="text-center">
                      {{ formatPaymentType(item.paymentType) }}
                    </td> -->
                    <td class="text-center">
                      <v-btn
                        color="primary"
                        variant="flat"
                        size="small"
                        style="margin-right: 10px;"
                        @click="handleEdit(item, index)"
                      >
                        编辑
                      </v-btn>
                      <v-btn
                        color="error"
                        variant="tonal"
                        size="small"
                        @click="handleDelete(item, index)"
                      >
                        删除
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </tbody>
            </v-table>
  
            <!-- 分页区域 -->
            <div class="custom-pagination d-flex align-center justify-space-between">
              <div class="pagination-info">共 {{ total }} 条记录</div>
              
              <div class="d-flex align-center">
                <div class="pagination-controls">
                  <v-btn
                    icon="mdi-chevron-double-left"
                    variant="text"
                    density="comfortable"
                    :disabled="currentPage === 1"
                    @click="currentPage = 1"
                    class="pagination-btn"
                  />
                  <v-btn
                    icon="mdi-chevron-left"
                    variant="text"
                    density="comfortable"
                    :disabled="currentPage === 1"
                    @click="currentPage--"
                    class="pagination-btn"
                  />
                  <span class="pagination-text mx-2">{{ currentPage }} / {{ totalPages }}</span>
                  <v-btn
                    icon="mdi-chevron-right"
                    variant="text"
                    density="comfortable"
                    :disabled="currentPage === totalPages"
                    @click="currentPage++"
                    class="pagination-btn"
                  />
                  <v-btn
                    icon="mdi-chevron-double-right"
                    variant="text"
                    density="comfortable"
                    :disabled="currentPage === totalPages"
                    @click="currentPage = totalPages"
                    class="pagination-btn"
                  />
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
  
        <!-- 添加供应商对话框 -->
        <v-dialog v-model="showAddDialog" max-width="860" max-height="700px" persistent>
          <v-card class="delete-confirm-dialog">
            <v-card-title class="d-flex justify-space-between align-center">
              <span>{{ addFormTitle }}</span>
              <v-btn
                icon="mdi-close"
                variant="text"
                @click="handleCloseDialog"
              />
            </v-card-title>
            <v-card-text>
              <div class="d-flex gap-2" style="margin-bottom: 20px;">
                <v-textarea style="width: 400px;" :class="{ 'v-field--readonly': addFormTitle !== '新增供应商' }" :readonly="addFormTitle !== '新增供应商'" auto-grow resize v-model="companyName" rows="1" label="公司全称（必填）" persistent-placeholder variant="outlined" density="compact" hide-details ></v-textarea> 
                <v-textarea style="width: 400px;" auto-grow resize v-model="supplierAddress" rows="1" label="供应商地址" persistent-placeholder variant="outlined" density="compact" hide-details ></v-textarea>
              </div>
              <div class="d-flex gap-2" style="margin-bottom: 20px;">
                <v-text-field style="width: 400px;" v-model="openingBank" label="开户行" persistent-placeholder variant="outlined" density="compact" hide-details />
                <v-text-field style="width: 400px;" v-model="bankAccount" label="银行账户" persistent-placeholder variant="outlined" density="compact" hide-details />
              </div>
              <div class="d-flex gap-2">
                <div class="d-flex gap-2">
                    <v-text-field style="width: 197px;" v-model="contactPerson" label="联系人" persistent-placeholder variant="outlined" density="compact" hide-details />
                    <v-text-field style="width: 197px;" v-model="phone" label="电话" persistent-placeholder variant="outlined" density="compact" hide-details />
                    <v-select
                      label="税别"
                      persistent-placeholder
                      style="width: 128px;"
                      v-model="taxType"
                      :items="taxTypeOptions"
                      item-title="title"
                      item-value="value"
                      variant="outlined"
                      density="compact"
                      hide-details
                    ></v-select>
                    <v-select
                      label="税率"
                      persistent-placeholder
                      style="width: 128px;"
                      v-model="rate"
                      :items="rateOptions"
                      item-title="title"
                      item-value="value"
                      variant="outlined"
                      density="compact"
                      hide-details
                    ></v-select>
                    <v-select
                      label="付款方式"
                      persistent-placeholder
                      style="width: 128px;"
                      v-model="paymentType"
                      :items="paymentTypeOptions"
                      item-title="title"
                      item-value="value"
                      variant="outlined"
                      density="compact"
                      hide-details
                    ></v-select>
                </div>
              </div>
              <div>
                <div style="margin: 20px 0 0 0;color: #fff;">供应商类型</div>
                <div class="allot-user-list">
                  <v-checkbox-group class="allot-user-radio-group">
                    <v-checkbox v-model="selectedSupplierType" v-for="item in supplierTypeList" :key="item.title" :label="item.title" :value="item.value" />
                  </v-checkbox-group>
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <div class="d-flex correlate-btn">
                <v-btn color="error" variant="tonal" @click="handleCloseDialog">取消</v-btn>
                <v-btn color="primary" variant="flat" @click="handleAddSupplier">确定</v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
        
        <!-- 上传对话框 -->
        <UploadImgDialog
          v-model="showUploadDialog"
          mode="new"
          type="image"
          @upload="handleNewImageUploadSuccess"
        />
  
        <!-- 删除确认对话框 -->
        <v-dialog v-model="deleteDialog" max-width="400">
          <v-card class="delete-dialog">
            <v-card-title class="text-h5">
              确认删除
            </v-card-title>
            <v-card-text>
              确定要删除供应商 "{{ selectedSupplier?.companyName }}" 吗？
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="error"
                variant="tonal"
                @click="deleteDialog = false"
              >
                取消
              </v-btn>
              <v-btn
                color="primary"
                variant="flat"
                @click="confirmDelete"
                :loading="deleteLoading"
              >
                确认删除
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </template>
  
  <script setup lang="ts">
  import { ref, computed, watch, onMounted } from 'vue'
  import { useSnackbar } from '@/composables/useSnackbar'
  import { contractApi, purchaseApi } from '@/services/api'
  import { bigClassOptions, getMaterialTypeOptions, materialUnitOptions } from '@/constants/contract'
  import UploadImgDialog from '@/components/UploadImgDialog.vue'
  
  interface Supplier {
    code: string
    bankAccount: string
    companyName: string
    contactPerson: string
    createTime: number
    id: number
    openingBank: string
    phone: string
    supplierAddress: string
    rate: string
    taxType: string
    paymentType: string
  }
  
  interface SearchForm {
    keyword: string
  }
  
  const { showSuccess, showError } = useSnackbar()
  // const taxTypeOptions = ref([
  //   { title: '一般纳税人', value: '一般纳税人' },
  //   { title: '小规模纳税人', value: '小规模纳税人' },
  //   { title: '个体工商户', value: '个体工商户' },
  //   { title: '零税', value: '零税' }
  // ])
  const taxTypeOptions = ref([
    { title: '零税', value: '0' },
    { title: '含税', value: '1' },
    { title: '未税', value: '2' }
  ])
  const rateOptions = ref([
    { title: '0%', value: '0%' },
    { title: '13%', value: '13%' },
  ])
  const isAddOrEdit = ref(false)
  // 表格列配置
  const headers = [
    { title: '供应商唯一码', key: 'code', align: 'center', width: '100px' },
    { title: '公司全称', key: 'companyName', align: 'center', width: '200px' },
    { title: '公司类型', key: 'type', align: 'center', width: '150px' },
    { title: '开户行', key: 'openingBank', align: 'center', width: '160px' },
    { title: '银行账号', key: 'bankAccount', align: 'center', width: '160px' },
    { title: '联系人', key: 'contactPerson', align: 'center', width: '80px' },
    { title: '电话', key: 'phone', align: 'center', width: '100px' },
    { title: '供应商地址', key: 'supplierAddress', align: 'center', width: '150px' },
    { title: '税别', key: 'taxType', align: 'center', width: '100px' },
    // { title: '付款方式', key: 'paymentType', align: 'center', width: '80px' },
    { title: '操作', key: 'action', align: 'center', width: '130px' }
  ]
  
  // 格式化付款方式
  const formatPaymentType = (value: string) => {
    const map: Record<string, string> = {
      '0': '预付',
      '1': '现付',
      '2': '月结'
    }
    return map[value] || '/'
  }

  // 获取付款方式的value（文字转value）
  const getPaymentTypeValue = (titleOrValue: string) => {
    const option = paymentTypeOptions.value.find(opt => opt.title === titleOrValue || opt.value === titleOrValue)
    return option?.value || titleOrValue
  }
  
  // 格式化税率
  const formatTaxRate = (value: string) => {
    const map: Record<string, string> = {
      '0': '0%',
      '13': '13%'
    }
    return map[value] || '0%'
  }
  // 税率的value (文字转value 去掉%)
  const getTaxRateValue = (titleOrValue: string) => {
    const option = rateOptions.value.find(opt => opt.title === titleOrValue || opt.value === titleOrValue)
    return option?.value.replace('%', '') || titleOrValue.replace('%', '')
  }

  // 格式化税别
  const formatTaxType = (value: string) => {
    const map: Record<string, string> = {
      '0': '零税',
      '1': '含税',
      '2': '未税'
    }
    return map[value] || '零税'
  }
  // 税别的value (文字转value)
  const getTaxTypeValue = (titleOrValue: string) => {
    const option = taxTypeOptions.value.find(opt => opt.title === titleOrValue || opt.value === titleOrValue)
    return option?.value || titleOrValue
  }
  const addFormTitle = ref('新增供应商')
  // 响应式数据
  const loading = ref(false)
  const currentPage = ref(1)
  const pageSize = ref(30)
  const total = ref(0)
  const supplierList = ref<Supplier[]>([])
  const searchForm = ref<SearchForm>({
    keyword: ''
  })
  
  // 计算属性
  const totalPages = computed(() => Math.ceil(total.value / pageSize.value))
  
  // 新增物料相关状态
  const showAddDialog = ref(false)
  const addForm = ref()
  const addFormValid = ref(false)
  const addLoading = ref(false)
  const newSupplier = ref<Supplier>({
    code: '',
    id: null,
    bankAccount: '',
    companyName: '',
    contactPerson: '',
    createTime: 0,
    openingBank: '',
    phone: '',
    supplierAddress: '',
    rate: '',
    taxType: '',
    paymentType: '',
  })
  
// 供应商表单相关变量
const showUploadDialog = ref(false)
const customMaterialImageUrls = ref<{ url: string; name: string }[]>([])
const companyName = ref('')  // 公司全称（必填）
const supplierAddress = ref('')  // 供应商地址（可选）
const contactPerson = ref('')  // 联系人（可选）
const phone = ref('')  // 电话（可选）
const rate = ref('')  // 税率（可选）
const taxType = ref('')  // 税别（可选）
const openingBank = ref('')  // 开户行（可选）
const bankAccount = ref('')  // 银行账户（可选）
const paymentType = ref('')  // 付款方式（可选）
const customMaterialBigClass = ref('')
const customMaterialType = ref('')
const customMaterialPrice = ref<number | null>(null)
const customMaterialUnit = ref('')
const customMaterialRemark = ref('')
const selectedSupplierType = ref<any[]>([])
const supplierTypeList = ref([
  { title: '板材类', value: '板材类' },
  { title: '包材类', value: '包材类' },
  { title: '刀具类', value: '刀具类' },
  { title: '封边条', value: '封边条' },
  { title: '胶水类', value: '胶水类' },
  { title: '木皮类', value: '木皮类' },
  { title: '泡棉类', value: '泡棉类' },
  { title: '沙发辅料类', value: '沙发辅料类' },
  { title: '实木类', value: '实木类' },
  { title: '维修类', value: '维修类' },
  { title: '研磨类', value: '研磨类' },
  { title: '杂项', value: '杂项' },
  { title: '油漆类', value: '油漆类' },
  { title: '灯具类', value: '灯具类' },
  { title: '小五金', value: '小五金' },
  { title: '玻璃类', value: '玻璃类' },
  { title: '大理石', value: '大理石' },
  { title: '岩板', value: '岩板' },
  { title: '人造石', value: '人造石' },
  { title: '布类', value: '布类' },
  { title: '皮革类', value: '皮革类' },
  { title: '外购类', value: '外购类' },
  { title: '金属类', value: '金属类' }
])
const paymentTypeOptions = ref([
  { title: '预付', value: '0' },
  { title: '现付', value: '1' },
  { title: '月结', value: '2' }
])
  // 删除相关状态
  const deleteDialog = ref(false)
  const deleteLoading = ref(false)
  const selectedSupplier = ref<Supplier | null>(null)
  const selectedIndex = ref(-1)
  
  // 防抖保存
  let saveTimers: { [key: number]: number | null } = {}
  
  const debouncedSave = (item: Supplier, index: number) => {
    // 清除该索引对应的旧定时器
    if (saveTimers[index]) {
      clearTimeout(saveTimers[index])
    }
    
    // 设置新的定时器
    saveTimers[index] = setTimeout(() => {
      handleSave(item, index)
      saveTimers[index] = null
    }, 1000) as unknown as number
  }
  
  // 加载物料列表
  const loadSupplierList = async () => {
    try {
      loading.value = true
      const res = await purchaseApi.vendorList({ 
        page: currentPage.value, 
        pageSize: pageSize.value,
        keyword: searchForm.value.keyword
      })
      if (res?.code === 0) {
        supplierList.value = res.data.records || []
        total.value = res.data.total || 0
      }
    } catch (error) {
      console.error('获取物料列表失败:', error)
    } finally {
      loading.value = false
    }
  }
  
  // 保存物料
  const handleSave = async (item: Supplier, index: number) => {
  //   if (!item.id) {
      try {
        const res = await contractApi.addPresetMaterial({
          id: item.id,
          materialName: item.materialName,
          specDesc: item.specDesc,
          bigClass: item.bigClass,
          materialType: item.materialType,
          materialUnit: item.materialUnit,
          materialRemark: item.materialRemark
        })
        if (res.code === 0) {
          // 更新ID
          supplierList.value[index].id = res.data.id
          // showSuccess('物料保存成功')
        } else {
          // showError(res.message || '保存失败')
        }
      } catch (error: any) {
        console.error('保存物料失败:', error)
        showError(error.message || '保存失败')
      }
  //   }
  }
  
  // 处理大类变化
  const handleChangeBigClass = (item: Supplier, index: number) => {
    item.materialType = ''
    debouncedSave(item, index)
  }
  
  // 方法
  const handleSearch = () => {
    currentPage.value = 1
    loadSupplierList()
  }
  
  const handleReset = () => {
    searchForm.value = {
      keyword: ''
    }
    handleSearch()
  }
  
const handleAdd = () => {
  addFormTitle.value = '新增供应商'
  showAddDialog.value = true
  selectedSupplierType.value = []
  companyName.value = ''
  supplierAddress.value = ''
  contactPerson.value = ''
  phone.value = ''
  rate.value = ''
  taxType.value = ''
  paymentType.value = ''
  openingBank.value = ''
  bankAccount.value = ''
  customMaterialBigClass.value = ''
  customMaterialType.value = ''
  customMaterialPrice.value = null
  customMaterialImageUrls.value = []
  customMaterialUnit.value = ''
  customMaterialRemark.value = ''
}

// 关闭对话框
const handleCloseDialog = () => {
  showAddDialog.value = false
  addFormTitle.value = '新增供应商'
  selectedSupplierType.value = []
  companyName.value = ''
  supplierAddress.value = ''
  contactPerson.value = ''
  phone.value = ''
  rate.value = ''
  taxType.value = ''
  paymentType.value = ''
  openingBank.value = ''
  bankAccount.value = ''
  customMaterialBigClass.value = ''
  customMaterialType.value = ''
  customMaterialPrice.value = null
  customMaterialImageUrls.value = []
  customMaterialUnit.value = ''
  customMaterialRemark.value = ''
}
  
  // 处理大类变化 - 自定义物料
  const handleChangeCustomBigClass = () => {
    customMaterialType.value = ''
  }
  
  // 处理新增物料图上传
  const handleNewImageUpload = () => {
    showUploadDialog.value = true
  }
  
  // 处理图片上传成功
  const handleNewImageUploadSuccess = (urls: string[]) => {
    customMaterialImageUrls.value = urls.map(url => ({
      url,
      name: `物料图_${Date.now()}`
    }))
    showUploadDialog.value = false
  }
  
// 添加供应商
const handleAddSupplier = async () => {
  if (!companyName.value || companyName.value.trim() === '') {
    showError('公司全称不能为空')
    return
  }
  if(isAddOrEdit.value){
    return
  }
  isAddOrEdit.value = true
  if(addFormTitle.value === '新增供应商'){
    const res = await purchaseApi.vendorAdd({
      companyName: companyName.value,
      supplierAddress: supplierAddress.value,
      contactPerson: contactPerson.value,
      phone: phone.value,
      rate: getTaxRateValue(rate.value),
      taxType: getTaxTypeValue(taxType.value),
      paymentType: getPaymentTypeValue(paymentType.value),
      openingBank: openingBank.value,
      bankAccount: bankAccount.value,
      type: selectedSupplierType.value.join(',')
    })
    if (res?.code === 0) {
      showSuccess('添加供应商成功')
      showAddDialog.value = false
      loadSupplierList()
    } else {
      showError(res?.message || '操作失败')
    }
    isAddOrEdit.value = false
  } else {
    const res = await purchaseApi.vendorUpdate({
      id: selectedSupplier.value.id,
      companyName: companyName.value,
      supplierAddress: supplierAddress.value,
      contactPerson: contactPerson.value,
      phone: phone.value,
      rate: getTaxRateValue(rate.value),
      taxType: getTaxTypeValue(taxType.value),
      paymentType: getPaymentTypeValue(paymentType.value),
      openingBank: openingBank.value,
      bankAccount: bankAccount.value,
      type: selectedSupplierType.value.join(',')
    })
    if (res?.code === 0) {
      showSuccess('更新供应商成功')
      showAddDialog.value = false
      // supplierList.value[selectedIndex.value] = {
      //   id: selectedSupplier.value.id,
      //   companyName: companyName.value,
      //   supplierAddress: supplierAddress.value,
      //   contactPerson: contactPerson.value,
      //   phone: phone.value,
      //   taxType: taxType.value,
      //   paymentType: paymentType.value,
      //   openingBank: openingBank.value,
      //   bankAccount: bankAccount.value,
      //   type: selectedSupplierType.value.join(',')
      // }
      selectedSupplier.value = null
      selectedIndex.value = -1
      loadSupplierList()
    } else {
      showError(res?.message || '操作失败')
    }
    isAddOrEdit.value = false
  }
}
  
// 编辑供应商
const handleEdit = (item: Supplier, index: number) => {
  showAddDialog.value = true
  selectedSupplier.value = item
  selectedIndex.value = index
  addFormTitle.value = item.companyName
  companyName.value = item.companyName
  supplierAddress.value = item.supplierAddress
  contactPerson.value = item.contactPerson
  phone.value = item.phone
  rate.value = formatTaxRate(item.rate)
  taxType.value = formatTaxType(item.taxType)
  paymentType.value = formatPaymentType(item.paymentType)
  openingBank.value = item.openingBank
  bankAccount.value = item.bankAccount
  selectedSupplierType.value = item.type ? item.type.split(',') : []
}

  // 删除供应商
  const handleDelete = (item: Supplier, index: number) => {
    selectedSupplier.value = item
    selectedIndex.value = index
    deleteDialog.value = true
  }
  
  const confirmDelete = async () => {
  //   if (!selectedMaterial.value?.id) {
  //     // 如果没有ID，说明是新增未保存的物料，直接从列表中移除
  //     supplierList.value.splice(selectedIndex.value, 1)
  //     deleteDialog.value = false
  //     selectedMaterial.value = null
  //     selectedIndex.value = -1
  //     return
  //   }
    
    try {
      deleteLoading.value = true
      const res = await purchaseApi.vendorDelete({
        id: selectedSupplier.value.id
      })
      if (res.code === 0) {
        showSuccess('删除成功')
        supplierList.value.splice(selectedIndex.value, 1)
      //   loadSupplierList()
      } else {
        showError(res.message || '删除失败')
      }
      deleteDialog.value = false
    } catch (error: any) {
      showError(error.message || '删除失败')
    } finally {
      deleteLoading.value = false
      selectedSupplier.value = null
      selectedIndex.value = -1
    }
  }
  
  // 监听分页变化
  watch([currentPage, pageSize], () => {
    window.scrollTo(0, 0)
    loadSupplierList()
  })
  
  // 初始化
  onMounted(() => {
    loadSupplierList()
  })
  </script>
  
  <style scoped>
  .search-input :deep(.mdi-magnify),
  .search-input :deep(.mdi-magnify::before),
  .search-input :deep(.mdi-close::before),
  .search-input :deep(.mdi-close-circle),
  .search-input :deep(.mdi-close) {
    color: #fff!important;
  }
  
  .material-library-page {
    min-height: 100vh;
    width: 100%;
    background-color: #2B2D33;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 16px;
  }
  
  .material-library-container {
    width: 100%;
    max-width: 1400px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  
  .text-primary {
    color: #D2475D !important;
  }
  
  .search-card {
    background-color: #2B2D33 !important;
    border: none !important;
    position: relative;
    z-index: 20;
  }
  
  .search-card :deep(.v-text-field) .v-field__input,
  .search-card :deep(.v-text-field) .v-field__field,
  .search-card :deep(.v-text-field) input,
  .search-card :deep(.v-text-field) .v-field__append-inner,
  .search-card :deep(.v-select) .v-field__input,
  .search-card :deep(.v-select) .v-field__field,
  .search-card :deep(.v-select) input,
  .search-card :deep(.v-select) .v-select__selection-text,
  .search-card :deep(.v-select) .v-select__selection,
  .search-card :deep(.v-select) .v-field__append-inner {
    color: #fff !important;
  }
  
  .search-card :deep(.v-text-field) .v-field__outline,
  .search-card :deep(.v-select) .v-field__outline {
    color: rgba(255, 255, 255, 0.12) !important;
  }
  
  .search-card :deep(.v-text-field) .v-field__input::placeholder {
    color: rgba(255, 255, 255, 0.7) !important;
  }
  
  .search-card :deep(.v-text-field) .v-label,
  .search-card :deep(.v-select) .v-label {
    color: rgba(255, 255, 255, 0.7) !important;
  }
  
  :deep(.v-card) {
    box-shadow: none !important;
    border: 1px solid rgba(255, 255, 255, 0.12) !important;
  }
  
  .table-card {
    background-color: #2B2D33 !important;
    flex: 1;
    display: flex;
    position: relative;
    z-index: 1;
  }
  
  .table-card :deep(.v-card-text) {
    padding: 16px;
  }
  
  .material-table {
    background-color: #2B2D33;
  }
  
  .material-table :deep(th) {
    background-color: #2B2D33 !important;
    color: rgba(255, 255, 255, 0.7) !important;
    font-weight: 500;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
    padding: 12px 8px !important;
  }
  
  .material-table :deep(td) {
    color: #fff !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
    padding: 8px !important;
  }
  
  .material-table :deep(tr:hover) {
    background-color: rgba(255, 255, 255, 0.05) !important;
  }
  
  .material-table :deep(.v-text-field) .v-field__input,
  .material-table :deep(.v-text-field) .v-field__field,
  .material-table :deep(.v-text-field) input,
  .material-table :deep(.v-textarea) .v-field__input,
  .material-table :deep(.v-textarea) .v-field__field,
  .material-table :deep(.v-textarea) textarea,
  .material-table :deep(.v-select) .v-field__input,
  .material-table :deep(.v-select) .v-field__field,
  .material-table :deep(.v-select) input,
  .material-table :deep(.v-select) .v-select__selection-text,
  .material-table :deep(.v-select) .v-select__selection {
    color: #fff !important;
  }
  
  .material-table :deep(.v-text-field) .v-field__outline,
  .material-table :deep(.v-textarea) .v-field__outline,
  .material-table :deep(.v-select) .v-field__outline {
    color: rgba(255, 255, 255, 0.12) !important;
  }
  
  .custom-pagination {
    padding: 16px;
    color: rgba(255, 255, 255, 0.7);
    border-top: 1px solid rgba(255, 255, 255, 0.12);
  }
  
  .custom-pagination .pagination-info {
    font-size: 14px;
  }
  
  .custom-pagination .pagination-controls {
    display: flex;
    align-items: center;
  }
  
  .custom-pagination .pagination-btn {
    color: rgba(255, 255, 255, 0.7) !important;
  }
  
  .custom-pagination .pagination-btn:hover {
    color: #fff !important;
  }
  
  .custom-pagination .pagination-btn:disabled {
    color: rgba(255, 255, 255, 0.3) !important;
  }
  
  .custom-pagination .pagination-text {
    font-size: 14px;
  }
  
  .search-input {
    width: 100%;
  }
  
  .gap-2 {
    gap: 8px;
  }
  
  .search-btn {
    font-weight: 400;
    text-transform: none;
    letter-spacing: 0;
    font-size: 14px;
    padding: 0 16px;
    min-width: unset;
  }
  
  .delete-dialog {
    background-color: #2B2D33 !important;
  }
  
  .delete-dialog :deep(.v-card-title) {
    color: #fff !important;
  }
  
  .delete-dialog :deep(.v-card-text) {
    color: rgba(255, 255, 255, 0.7) !important;
  }
  
  .delete-dialog :deep(.v-btn) {
    text-transform: none;
    letter-spacing: 0;
  }
  
  :deep(th),:deep(td) {
    padding: 8px !important;
  }
  
  .no-img {
    background-color: rgba(0, 0, 0, 0.5);
    color: rgba(255, 255, 255, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    text-align: center;
    border-radius: 4px;
  }
  
  .img-icon-one {
    width: 32px;
    height: 32px;
    opacity: 0.5;
  }
  
  .material-image {
    display: block;
    margin: 0 auto;
    object-fit: cover;
  }
  
  .correlate-btn {
    width: 100%;
    justify-content: flex-end;
    gap: 10px;
    padding: 0 16px 16px;
  }
  
  .delete-confirm-dialog {
    background-color: #2B2D33 !important;
  }
  
  .delete-confirm-dialog :deep(.v-card-title) {
    color: #fff !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    padding: 16px;
  }
  
  .delete-confirm-dialog :deep(.v-card-text) {
    color: rgba(255, 255, 255, 0.7) !important;
    padding: 24px 16px;
  }
  
  .delete-confirm-dialog :deep(.v-text-field) .v-field__input,
  .delete-confirm-dialog :deep(.v-text-field) .v-field__field,
  .delete-confirm-dialog :deep(.v-text-field) input,
  .delete-confirm-dialog :deep(.v-textarea) .v-field__input,
  .delete-confirm-dialog :deep(.v-textarea) .v-field__field,
  .delete-confirm-dialog :deep(.v-textarea) textarea,
  .delete-confirm-dialog :deep(.v-select) .v-field__input,
  .delete-confirm-dialog :deep(.v-select) .v-field__field,
  .delete-confirm-dialog :deep(.v-select) input,
  .delete-confirm-dialog :deep(.v-select) .v-select__selection-text,
  .delete-confirm-dialog :deep(.v-select) .v-select__selection {
    color: #fff !important;
  }
  
  .delete-confirm-dialog :deep(.v-text-field) .v-field__outline,
  .delete-confirm-dialog :deep(.v-textarea) .v-field__outline,
  .delete-confirm-dialog :deep(.v-select) .v-field__outline {
    color: rgba(255, 255, 255, 0.12) !important;
  }
  
  .delete-confirm-dialog :deep(.v-text-field) .v-label,
  .delete-confirm-dialog :deep(.v-textarea) .v-label,
  .delete-confirm-dialog :deep(.v-select) .v-label {
    color: rgba(255, 255, 255, 0.7) !important;
  }
  
  .delete-confirm-dialog :deep(.v-btn) {
    text-transform: none;
    letter-spacing: 0;
  }
  
  :deep(.v-list-item__content) {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }
  
  :deep(.material-name-list)::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  
  :deep(.material-name-list)::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
  }
  
  :deep(.material-name-list)::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 3px;
  }
  
  :deep(.material-name-list)::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.4);
  }

  
  :deep(.delete-confirm-dialog .v-field--readonly ) {
    background-color: rgba(255, 255, 255, 0.05) !important;
  }

  :deep(.delete-confirm-dialog .allot-user-list .v-input__control) {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  :deep(.delete-confirm-dialog .allot-user-radio-group .v-input) {
    float: left;
    width: 20%!important;
    height: 50px;
  }

  :deep(.delete-confirm-dialog .allot-user-radio-group .v-selection-control .v-label) {
    color: #fff !important;
  }
</style>
  
  